import { createRouter, createWebHistory } from 'vue-router';
import ViewData from './viewdata.vue'; // 确保路径正确


const routes = [
  {
    path: '/',
    name: 'ViewData',
    component: ViewData // 将 ViewData 设置为首页
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;